export default "__VITE_ASSET__C2i$z0xr__"